import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-review",
  "use": "icon-review-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-review\">\n<path d=\"M100,13.8c-30,0-61.4,6.6-90.1,17c9,61.4,41.8,117.5,90.1,155.4c48.4-37.8,80.9-93.9,90.1-155.4\n\tC161.3,20.4,130,13.8,100,13.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/review.svg
// module id = 3epJ
// module chunks = 3